import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { Observable, timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from '../../common/decorators';
import { PlannerProfile, PlannerProfileBriefListSearchCriteria, PlannerProfileListFacade } from '../../store/models';
import { FilterSearch, FilterSelect, FilterSettings, SelectOption } from '../../ui-kit/list-filter';
import { ListQueryParam, ListRange, ListServerPaginationStateModel, ListServerPagination } from '../../common';
import { ButtonAction } from '../../ui-kit/action-button';
import { PlannerProfileType } from '../../store/constants/planner-profile.constant';
import { HubContextFacade } from '../../store';

@Component({
    selector: 'lib-profiles-dialog',
    templateUrl: './profiles-dialog.component.html',
    styleUrls: ['./profiles-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
@AutoUnsubscribe
export class ProfilesDialogComponent
  extends ListServerPagination<PlannerProfile>
  implements OnInit, AfterViewInit, OnDestroy
{
  displayedColumns = ['name', 'description'];
  filterConfig: FilterSettings;
  listDto$: Observable<ListServerPaginationStateModel<PlannerProfile>>;
  searchCriteriaValue = new PlannerProfileBriefListSearchCriteria();
  buttonAction = ButtonAction;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  private plannerProfileListFacade: PlannerProfileListFacade;

  constructor(
    translateService: TranslateService,
    public dialogRef: MatDialogRef<ProfilesDialogComponent>,
    public hubContextFacade: HubContextFacade,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      plannerProfileListFacade: PlannerProfileListFacade;
      title: string;
      displayedColumns?: string[];
      filterConfig?: FilterSettings;
    },
  ) {
    super(translateService);
  }

  ngOnInit(): void {
    this.plannerProfileListFacade = this.data.plannerProfileListFacade;
    this.listDto$ = this.plannerProfileListFacade.listDto$;
    if (this.data.displayedColumns) {
      this.displayedColumns = this.data.displayedColumns;
    }
    this.initFiltersForm();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  ngOnDestroy(): void {
    this.plannerProfileListFacade.setInitialState();
  }

  fetchList(listRange: ListRange): void {
    timer(0)
      .pipe(take(1))
      .subscribe(() => {
        this.searchCriteriaValue = {
          ...this.searchCriteriaValue,
          ...listRange,
        };
        this.plannerProfileListFacade.loadListForDialog(
          new PlannerProfileBriefListSearchCriteria(this.searchCriteriaValue),
        );
      });
  }

  fetchListBySearchCriteria(filterValue: PlannerProfileBriefListSearchCriteria): void {
    this.searchCriteriaValue = {
      ...this.searchCriteriaValue,
      ...filterValue,
      page: 0,
    };
    this.plannerProfileListFacade.loadListForDialog(
      new PlannerProfileBriefListSearchCriteria(this.searchCriteriaValue),
    );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private initFiltersForm(): void {
    this.filterConfig = this.data.filterConfig || {
      items: [
        new FilterSearch({ name: ListQueryParam.Filter }),
        new FilterSelect({
          name: ListQueryParam.Type,
          label: 'common.filter.profileType.label',
          options: Object.values(PlannerProfileType).map(
            (option: string) =>
              new SelectOption({
                name: 'common.filter.profileType.option.' + option.toLowerCase(),
                value: option,
              }),
          ),
        }),
      ],
    };
  }
}
